module.exports = __webpack_public_path__ + "media/images/default/pages/about/main/33822-974cc0e0d89eaeea7db43b9ec6a6f4e4.svg";